<template>
  <div class="make-block" align="center">
    <div class="center-block">
      <transition-group name='fade' tag='div'>
        <div
         v-for="number in [currentNumber]"
         :key='number'
         >
          <img
            :src="currentImage"
            v-on:mouseover="stopRotation"
            v-on:mouseout="startRotation"
          />
        </div>
      </transition-group>
      <a class="prev" @click="prev" href="#"></a>
      <a class="next" @click="next" href="#"></a>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      images: [require("@/assets/protester6.jpg"),require("@/assets/protester3.jpeg"),require("@/assets/protester5.jpg"),require("@/assets/protester8.jpeg"),require("@/assets/protester7.jpg"),require("@/assets/protester2.png")],
      currentNumber: 0,
      timer: null
    }
  },

  mounted: function () {
    this.startRotation();
  },

  methods: {
    startRotation: function() {
      this.timer = setInterval(this.next, 5000);
    },

    stopRotation: function() {
      clearTimeout(this.timer);
      this.timer = null;
    },

    next: function() {
      this.currentNumber += 1
    },
    prev: function() {
      this.currentNumber -= 1
    }
  },
  
  computed: {
    currentImage: function() {
      return this.images[Math.abs(this.currentNumber) % this.images.length];
    }
  }
}
</script>

<style>
.make-block {
  position: relative;
}
.center-block {
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.9s ease;
  overflow: hidden;
  visibility: visible;
  position: block;
  width:100%;
  opacity: 1;
}

.fade-enter,
.fade-leave-to {
  visibility: hidden;
  position: absolute;
  width:100%;
  opacity: 0;
}

img {
  height:300px;
  width:720px;
}

.prev, .next {
  cursor: pointer;
  position: absolute;
  top: 0px;
  width: 30%;
  height: 300px;
  padding: 16px;
  color: white;
  font-weight: bold;
  font-size: 18px;
  transition: 0.7s ease;
  border-radius: 0 4px 4px 0;
  text-decoration: none;
  user-select: none;
  opacity: 0;
}

.prev:hover, .next:hover {
  opacity: 0.6;
}

.next {
  left: 70%;
  background-color: #202b38;
}

.prev {
  left: 0;
  background-color: #202b38;
}
</style>